<template>
        <v-card class="mx-auto" width="100%">
            <v-container grid-list-md fluid>
                <v-layout row>
                    <v-flex xs12 class="pb-0">
                        <v-card-title class="pb-0">Caso {{ caseNumber }} - Situación {{ situationNumber }}</v-card-title>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex xs12>
                        <v-card-text class="teal--text text--darken-3 subtitle-1">
                            {{ situation }}
                        </v-card-text>
                    </v-flex>
                </v-layout>
                <v-divider class="teal lighten-3"></v-divider>
                <!-- Situación Normal: ********************************************-->
                <v-layout v-if="situationType === '1'" row justify-center>
                    <v-flex xs12 sm6 md4 v-for="(answer, i) in situationAnswers" align-self-center>
                        <v-card class="mx-auto" :key="i" elevation="10">
                            <v-card-title :class="answer.contestada==='0' ? 'grey--text' : (answer.contestada==='1' ? 'pink--text text--lighten-3' : 'pink--text text--darken-4')" class="body-1 font-weight-bold pt-3 pb-2">
                                {{ answer.respuesta }}
                            </v-card-title>
                            <v-card-text class="pt-0 pb-0">
                                {{ answer.desglose }}
                                <v-radio-group
                                    dense
                                    v-model="answer.contestada"
                                    row
                                >
                                    <v-radio
                                        label="No"
                                        color="grey"
                                        value="0"
                                    ></v-radio>
                                    <v-radio
                                        label="Débil"
                                        color="pink lighten-3"
                                        value="1"
                                    ></v-radio>
                                    <v-radio
                                        label="Fuerte"
                                        color="pink darken-4"
                                        value="3"
                                    ></v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
                <!-- Situación Priorizada: ********************************************-->
                <v-layout v-else row justify-center>
                    <v-flex xs12 sm6 md4 v-for="(answer, i) in situationAnswers" align-self-center>
                        <v-card class="mx-auto" :key="i" elevation="10">
                            <!-- <v-card-title :class="answer.contestada==='0' ? 'grey--text' : (answer.contestada==='1' ? 'pink--text text--lighten-3' : 'pink--text text--darken-4')" class="body-1 font-weight-bold pt-3 pb-2">
                                {{ answer.respuesta }}
                            </v-card-title> -->
                            <v-card-text class="pt-0 pb-0">
                                {{ answer.respuesta }}
                                <v-select
                                    :dense="bDense"
                                    prepend-icon="mdi-order-numeric-ascending"
                                    :items="orderValues"
                                    item-text="orden"
                                    item-value="ordenid"
                                    label="Orden de Prioridad"
                                    v-model="answer.contestada"
                                    color="teal darken-3"
                                    item-color="teal darken-3"
                                    no-data-text="No hay rangos de prioridad registrados."
                                    :readonly="false"
                                ></v-select>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'CaseSituation',
    data() {
        return {
            bDense: true,
            orderValues: [
                {
                    ordenid: 0,
                    orden: 'Seleccione un orden de prioridad',
                },
                {
                    ordenid: 1,
                    orden: '1',
                },
                {
                    ordenid: 2,
                    orden: '2',
                },
                {
                    ordenid: 3,
                    orden: '3',
                },
                {
                    ordenid: 4,
                    orden: '4',
                },
                {
                    ordenid: 5,
                    orden: '5',
                },
                {
                    ordenid: 6,
                    orden: 'Eliminó',
                },
            ]
        };
    },
    created() {},
    props: {
        caseNumber: Number,
        situationNumber: Number,
        situationType: String,
        situation: String,
        situationAnswers: Array
    },
    methods: {

    },
    computed: {
        ...mapGetters(['waitCursor']),

        imgHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '200px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '250px';
            } else {
                height = '300px';
            }
            return height;
        },

    }
};
</script>

<style scoped>

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>